import axios from 'axios';

export const sendFinanceRequest = (data) => {
  return new Promise((resolve, reject) => {
    let body = { data: data };
    // console.log(body);
    console.log('Sending budget calc request:', data);
    axios
      .post(
        'https://us-central1-fasttrack-client.cloudfunctions.net/api/budgetcalc',
        // 'http://localhost:5001/fasttrack-client/us-central1/api/budgetcalc',
        body,
        { timeout: 24 * 60 * 60 * 1000 }, // Set a long timeout (24 hours)
      )
      // .post('https://www.suzuki-fasttrack.co.za/budgetcalc', body)
      // .post('http://localhost:5000/budgetcalc', body)
      .then((res) => {
        console.log('Budget Calc response: ', res.data);
        resolve(res.data);
      })
      .catch((e) => {
        // Check if the error has a response property
        if (e.response) {
          // Reject with the response data if available
          reject(e.response.data);
        } else {
          // Reject with the entire error object if response data is not available
          reject(e);
        }
      });
  });
};
